// Shared dark-bubble tooltip style — was independently copy-pasted as
// RAIL_TOOLTIP_SX (Navbar/LeftNav.jsx) and TAB_TOOLTIP_SX
// (Dashboard/DashboardScratch/components/ContactsPanel.jsx), same colors/
// shadow logic, tiny variations in size only. Extracted here as the single
// source of truth for new callers (Inbox icon-button tooltips, 2026-08-29) —
// the two existing spots aren't migrated, just not worth re-diffing them
// today, but should point here next time either is touched.
export const DARK_BUBBLE_TOOLTIP_SX = {
  tooltip: {
    sx: {
      backgroundColor: (theme) => (theme.palette.mode === "dark" ? "#E2E2E4" : "#1A1A1A"),
      color: (theme) => (theme.palette.mode === "dark" ? "#1A1A1A" : "#F5F5F5"),
      fontSize: "0.75rem",
      fontWeight: 500,
      borderRadius: "6px",
      px: 1.25,
      py: 0.625,
      boxShadow: (theme) =>
        theme.palette.mode === "dark" ? "0 6px 16px rgba(0,0,0,0.35)" : "0 4px 12px rgba(0,0,0,0.15)",
    },
  },
  arrow: {
    sx: {
      color: (theme) => (theme.palette.mode === "dark" ? "#E2E2E4" : "#1A1A1A"),
      boxShadow: "none",
      filter: "none",
    },
  },
};
